import { useTranslation } from 'react-i18next';
import styles from '../Reservation/reservation.module.css';
import Button from '../../components/Common/Button/Button';
import Header from '../../components/Common/Header/Header';
import ContentApp from '../../components/ContentApp';
import SuccessCheck from '../../components/icons/SuccessCheck';
import FixedButton from '../../components/Common/FixedButton/FixedButton';

const SuccessEmailChange = ({ history }) => {
  const { t } = useTranslation();

  return (
    <>
      <Header showBack={false} />
      <ContentApp classes='pt-0'>
        <div className={`d-flex align-items-center justify-content-center ${styles.iconContainer}`}>
          <SuccessCheck color='var(--color-primary)' size={200} />
        </div>

        <div className='mt-5 pt-3 px-3'>
          <div className={`bold text-left font-large ${styles.title}`}>
            {t('yourEmailUpdatedSuccessfully')}
          </div>

          <div className='text-secondary semi-bold font-normal text-left mt-3'>
            {t('newEmailAddress')}
          </div>
        </div>

        <FixedButton>
          <Button
            text={t('returnHome')}
            size='large'
            className={`mt-2 ${styles.btn}`}
            onClick={() => history.push('/')}
            icon
            typeIcon='arrow'
            iconColor='#000'
          />
        </FixedButton>
      </ContentApp>
    </>
  );
};

export default SuccessEmailChange;
